import { IconButton, IconButtonProps, SxProps } from '@mui/material';

interface MuiIconButtonProps extends IconButtonProps {
  sx?: SxProps;
}

export function MuiIconButton(props: MuiIconButtonProps) {
  const { sx, ...rest } = props;

  return (
    <IconButton sx={{ ...sx }} {...rest}>
      {props.children}
    </IconButton>
  );
}
